import { Link } from 'react-router-dom';
import { ArrowRight, Sparkles } from 'lucide-react';

export const ActivityEmptyState = () => {
  return (
    <div className="rounded-[32px] border border-dashed border-domino-cardBorder bg-domino-warm px-8 py-16 text-center shadow-[var(--domino-shadow-soft)]">
      <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-2xl bg-domino-aubergine text-white">
        <Sparkles className="h-5 w-5" />
      </div>
      <h2 className="mt-5 text-2xl font-semibold tracking-tight text-gray-950">
        Aucune activité récente
      </h2>
      <p className="mx-auto mt-3 max-w-xl text-sm leading-6 text-gray-600">
        Domino commencera à construire votre mémoire de travail dès que vous lancerez un outil.
        Commencez par analyser un call, préparer un follow-up ou générer un brief de meeting.
      </p>
      <div className="mt-6">
        <Link
          to="/tools"
          className="inline-flex items-center gap-2 rounded-xl bg-domino-aubergine px-4 py-2.5 text-sm font-medium text-white transition hover:bg-domino-prune"
        >
          Ouvrir les outils
          <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </div>
  );
};
